import React from 'react';

const HelpPicture = (_) => {

    return (
		<div>
			<h2 className="text-center dark"> Kaninprofil </h2>
		
			Denna länk går till en skrivskyddad profilsida för kaninen som vem som helst kan nå.
			Du kan använda den för att visa upp dina kaniner någon annanstans, med den information
			som du redan skrivit in i registret.
			I värsta fall kan profilsidan användas vid efterlysning om din kanin skulle råka hoppa vilse.
		</div>
	)
}

export default HelpPicture;